export interface BuildAlternateRowIdInput {
  tableId: string;
  anchorCartEntryId: number | null;
  productCode: string;
}

export function buildAlternateRowId({ tableId, anchorCartEntryId, productCode }: BuildAlternateRowIdInput): string {
  const anchorId = anchorCartEntryId === null ? "root" : String(anchorCartEntryId);

  return `${tableId}:alternate:${anchorId}:${productCode}`;
}
